const AbbsFeeHeader = [
    { id: 1, label: "Total BBA course fee (INR)", var: "coursefee" },
    { id: 2, label: "Total hostel fee for BBA students (INR)", var: "hostelfee" },
];

export default AbbsFeeHeader;
